<template>
  <div class="modal" v-if="isShowModal">
    <div class="modal-overlay" />
    <div class="modal-wrapper">
      <div class="modal-content-wrapper">
        <component :is="modal.component" />
        <ModalButtonClose @click="hideModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ModalButtonClose from '@components/modals/modal-button-close.vue'

export default {
  name: 'modal',
  components: {
    ModalButtonClose
  },
  computed: {
    ...mapState('modal', ['modal']),
    ...mapGetters('modal', ['isShowModal'])
  },
  methods: {
    ...mapActions('modal', ['hideModal'])
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 9999;
  -webkit-overflow-scrolling: touch;
}

.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: .8;
  z-index: 0;
}

.modal-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 608px;
  margin: 50px auto;
  background-image:
    url(~@images/modal/bg_modal-top.png),
    url(~@images/modal/bg_modal-bottom.png),
    url(~@images/modal/bg_modal-middle.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: 0 0, 0 100%, 0 80px;
  background-size: 608px 80px,  608px 80px,  608px calc(100% - 160px);
}

.modal-content-wrapper {
  padding-bottom: 80px;
}

.modal-content {
  margin: 0 auto;
}

.modal-button-close {
  top: -12px;
  right: -2px;
}
</style>
